import Host from '../components/templates/[host-id]';

export const HostContainer = () => {
  return <Host />;
};
